module.exports = __webpack_public_path__ + "img/play.97120506.svg";